import React from 'react';
import classnames from 'classnames';
import ImageIcon from '@wix/da-ds/pkg/Icons/32x32/AddImage';
import { useTranslation } from 'react-i18next';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import TextTooltipOnHover from '../../../Popover/Preset/TextTooltipOnHover';
import { MAX_WIDTH_FOR_TOOLTIP } from './constants';
import s from './Unknown.scss';
var UnknownDumbView = function (_a) {
    var width = _a.width, height = _a.height, className = _a.className, ariaHidden = _a["aria-hidden"];
    var t = useTranslation().t;
    return width && width > MAX_WIDTH_FOR_TOOLTIP ? (React.createElement("div", { style: { width: width, height: height }, className: classnames(className, s['root']), "aria-hidden": ariaHidden },
        React.createElement("div", null,
            React.createElement(ImageIcon, { size: IconSize.BIG, className: s['imageicon'] })),
        React.createElement("div", { className: s['nopreview'] }, t('deviationview.unknown.nopreview')))) : (React.createElement(TextTooltipOnHover, { tooltipText: t('deviationview.unknown.nopreview') },
        React.createElement("div", { style: { width: width, height: height }, className: classnames(className, s['root']), "aria-hidden": ariaHidden },
            React.createElement("div", null,
                React.createElement(ImageIcon, { size: IconSize.BIG, className: s['imageicon'] })))));
};
export default UnknownDumbView;
//# sourceMappingURL=Unknown.js.map